import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@gsa/afp-component-library';
import './source-badge.css';

// Small colored tag indicating a make/model entry source.
const SourceBadge = ({ badge = null, className = '' }) => {
  if (!badge) return null;
  return (
    <Tag
      variant={badge.variant}
      className={`source-badge radius-md padding-x-05 ${className}`}
    >
      {badge.label}
    </Tag>
  );
};

SourceBadge.propTypes = {
  badge: PropTypes.shape({
    label: PropTypes.string,
    variant: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default SourceBadge;
